import { Table } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { openUpdateTaskModal } from '@v2/domains/task/views/UpdateTaskModal.view'

import dayjs from 'src/common/libs/dayjs'

import { IGetTasksParams, ITask } from '../../task.types'
import {
  getAction,
  getStatus,
  getSubject,
} from '../../utils/stringConverter.util'
import styles from './task-table.module.scss'

interface TaskTableProps {
  tasks: ITask[]
  getTasksParamsForm: UseFormReturnType<
    IGetTasksParams,
    (values: IGetTasksParams) => IGetTasksParams
  >
  resetPaginate: () => void
}

const TasksTable = ({
  tasks,
  getTasksParamsForm,
  resetPaginate,
}: TaskTableProps) => {
  const { subject } = getTasksParamsForm.getValues()

  return (
    <Table
      layout="fixed"
      classNames={{
        table: styles.table,
        thead: styles['table-head'],
        th: styles['table-th'],
        td: styles['table-td'],
      }}
      highlightOnHover={true}
      withTableBorder={true}
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Name</Table.Th>
          <Table.Th>Type</Table.Th>
          <Table.Th> Action </Table.Th>
          {!!subject && <Table.Th> Subject </Table.Th>}
          <Table.Th>Assigned To</Table.Th>
          <Table.Th>Status</Table.Th>
          <Table.Th>Priority</Table.Th>
          <Table.Th>Due Date</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {tasks.map((task) => (
          <Table.Tr
            key={`${task.id}`}
            className={styles['table-tr']}
            onClick={() =>
              openUpdateTaskModal({
                selectedItem: task,
                resetPaginate,
              })
            }
          >
            <Table.Td fw="800">
              {`${task.person?.firstName ?? ''}  ${
                task.person?.lastName ?? ''
              }`}
            </Table.Td>
            <Table.Td fw="regular" ta="center">
              {task.type}
            </Table.Td>
            <Table.Td fw="regular" ta="center">
              {getAction(task.action)}
            </Table.Td>
            {!!subject && (
              <Table.Td fw="regular" ta="center">
                {getSubject(task.subject)}
              </Table.Td>
            )}
            <Table.Td fw="regular" ta="center">
              {`${task?.assignedTo?.firstName ?? ''} ${
                task?.assignedTo?.lastName?.slice(0, 1) ?? ''
              }.`}
            </Table.Td>
            <Table.Td fw="regular" ta="center">
              {getStatus(task.status)}
            </Table.Td>
            <Table.Td fw="bold" mod={{ color: task.priority }} ta="center">
              {task.priority}
            </Table.Td>
            <Table.Td fw="regular" ta="center">
              {dayjs.tz(task?.activityDate).isValid()
                ? dayjs.tz(task?.activityDate, 'UTC').format('MM/DD/YYYY')
                : ''}
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  )
}

export default TasksTable
